<p
  [ngClass]="{ full: template === TEMPLATES.Full, mini: template === TEMPLATES.Mini, btn: template === TEMPLATES.Btn }"
  *ngIf="sessionTimer || localTimer"
>
  <ng-container *ngIf="sessionTimer">
    <ng-container *ngIf="iconSession"> <ion-icon name="hourglass-outline"></ion-icon>&nbsp; </ng-container>
    <span>{{ codereTimerService.sessionTime() }}</span>
  </ng-container>

  <ng-container *ngIf="sessionTimer && localTimer"> &nbsp;<span>|</span>&nbsp; </ng-container>

  <ng-container *ngIf="localTimer">
    <ng-container> <ion-icon *ngIf="iconLocal" name="time-outline"></ion-icon>&nbsp; </ng-container>
    <span>{{ codereTimerService.localTime().toLowerCase() }}</span>
  </ng-container>
</p>
